import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { CampaignAnnouncementDialog } from '@/features/campaign-banner/components/CampaignAnnouncementDialog'
import {
  AgentTeamSection,
  EcosystemSection,
  FinalCtaSection,
  HeroSection,
  MediaGenerationSection,
  ModelCatalogSection,
  OneEndpointSection,
  ProofStrip,
  ProviderTiersSection,
} from '@/features/home/components'
import { generateLinks, generateMetaTags, routeSEO } from '@/lib/seo'
import { getSoftwareApplicationSchema, renderJsonLd } from '@/lib/structured-data'

export const Route = createFileRoute('/')({
  head: () => ({
    meta: generateMetaTags(routeSEO['/']),
    links: generateLinks(routeSEO['/']),
  }),
  component: HomePage,
})

function HomePage() {
  return (
    <div className="relative min-h-screen flex flex-col overflow-x-clip bg-[var(--color-bg-primary)]">
      {/* Structured Data — Organization + WebSite are already rendered
          sitewide by __root.tsx; only the homepage-specific SoftwareApplication
          schema belongs here. */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: renderJsonLd(getSoftwareApplicationSchema()) }}
      />

      <CampaignAnnouncementDialog />
      <Header />

      <main className="flex flex-col">
        <HeroSection />
        <ProofStrip />
        <OneEndpointSection />
        <ProviderTiersSection />
        <AgentTeamSection />
        <MediaGenerationSection />
        <ModelCatalogSection />
        <EcosystemSection />
        <FinalCtaSection />
      </main>

      <Footer />
    </div>
  )
}
